import React, { useState, useContext } from "react";

import {
  Grid,
  TextField,
  Button,
  Chip,
  InputAdornment,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AddIcon from "@material-ui/icons/Add";

import useForm from "../utils/useForm";
import SetupContext from "./context";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
  },
  selectedAccess: {
    display: "flex",
    flexWrap: "wrap",
    marginTop: theme.spacing(2),
    marginLeft: theme.spacing(2),
    "& > *": {
      margin: theme.spacing(0.5),
    },
  },
  addButton: {
    marginTop: theme.spacing(1.25),
    marginLeft: theme.spacing(1),
  },
  addInput: {
    marginTop: theme.spacing(1),

    minWidth: "50%",
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

export const AccessAndCapacity = () => {
  const { state, dispatch } = useContext(SetupContext);
  const { yardInfo } = state;
  const { handleChange } = useForm(state, dispatch, "yardInfo");
  const [newAcess, setNewAcess] = useState();
  const classes = useStyles();

  const addAccess = () => {
    if (!newAcess || yardInfo.accessToRailHighway.includes(newAcess)) return;
    dispatch({ type: "ADD_ACCESS", payload: newAcess });
    setNewAcess("");
  };

  const deleteAccess = (toDelete) => {
    dispatch({ type: "REMOVE_ACCESS", payload: toDelete });
  };

  const handleAccessSubmit = (evt) => {
    evt.preventDefault();
    addAccess();
  };
  let { errors } = state;

  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item xs={12} sm={6}>
        <TextField
          name="lotCapacityAcres"
          label="Open Air Yard Capacity"
          id="outlined-margin-dense"
          helperText={
            errors["lotCapacityAcres"] ? errors["lotCapacityAcres"] : ""
          }
          error={errors["lotCapacityAcres"] ? true : false}
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">Acres</InputAdornment>
            ),
          }}
          autoFocus
          required
          type="number"
          margin="dense"
          variant="outlined"
          fullWidth
          value={yardInfo.lotCapacityAcres}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="warehouseCapacity"
          label="Covered / Warehouse capacity"
          required
          margin="dense"
          helperText={
            errors["warehouseCapacity"] ? errors["warehouseCapacity"] : ""
          }
          error={errors["warehouseCapacity"] ? true : false}
          variant="outlined"
          fullWidth
          type="number"
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">SqFt</InputAdornment>
            ),
          }}
          value={yardInfo.warehouseCapacity}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="trackCapacity"
          label="Track capacity"
          margin="dense"
          helperText={errors["trackCapacity"] ? errors["trackCapacity"] : ""}
          error={errors["trackCapacity"] ? true : false}
          variant="outlined"
          fullWidth
          required
          type="number"
          InputProps={{
            endAdornment: (
              <InputAdornment position="start">Feet</InputAdornment>
            ),
          }}
          value={yardInfo.trackCapacity}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          name="servingCarrier"
          label="Serving Rail Carrier"
          margin="dense"
          helperText={errors["servingCarrier"] ? errors["servingCarrier"] : ""}
          error={errors["servingCarrier"] ? true : false}
          variant="outlined"
          fullWidth
          value={yardInfo.servingCarrier}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <Grid container>
          <Grid item xs={9}>
            <form onSubmit={handleAccessSubmit}>
              <TextField
                name="accessToRailHighway"
                label="Accessible Highway(s)"
                value={newAcess}
                size="small"
                fullWidth
                variant="outlined"
                className={classes.addInput}
                onChange={(evt) => setNewAcess(evt.target.value.toUpperCase())}
                inputProps={{
                  style: { textTransform: "uppercase" },
                }}
              />
            </form>
          </Grid>
          <Grid item xs={3}>
            <Button
              className={classes.addButton}
              size="medium"
              variant="outlined"
              onClick={addAccess}
              startIcon={<AddIcon />}
            >
              Add
            </Button>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.selectedAccess}>
              {yardInfo.accessToRailHighway.map((option) => (
                <Chip
                  variant="outlined"
                  key={option}
                  label={option}
                  onClick={() => alert}
                  onDelete={() => deleteAccess(option)}
                />
              ))}
            </div>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
